'use client'

import cx from 'classix'
import { type ReactNode, useRef } from 'react'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import focusStyle from '../../Shared/A11y/TabFocus.module.css'
import { useActiveLink } from '../../Shared/ctas/hooks/onActiveLink'
import ctaStyles from '../../Shared/ctas/SingleCtaOutlet.module.css'
import { TwoColumnsCtasWrapper } from '../../Shared/ctas/TwoColumnsCtasWrapper'
import styles from './HeroBannerCtas.module.css'

type HeroBannerCtasComponentProps = {
	readonly href: string
	readonly displayText: string
	readonly heroBannerImage: ReactNode
}

export function HeroBannerCtasSingleCta({
	href,
	displayText,
	heroBannerImage,
}: HeroBannerCtasComponentProps): ReactNode {
	const ref = useRef<HTMLAnchorElement>(null)
	const activeLink = useActiveLink(ref)

	return (
		<a
			href={href}
			className={cx(styles.bannerWrapper, focusStyle.bannerCtaFocus)}
			ref={ref}
			data-testid='landings.home.heroBannerCtasLink'
		>
			{heroBannerImage}
			<TwoColumnsCtasWrapper absolute>
				<div
					className={cx(
						ctaStyles.singleCta,
						applyStylesIf(activeLink, ctaStyles.active)
					)}
				>
					{displayText}
				</div>
			</TwoColumnsCtasWrapper>
		</a>
	)
}
